// removed by extract-text-webpack-plugin
module.exports = {"suffix":"_1344M7hKxyuMQnKOAHN06G","prefix":"_2aAvKVRafFOoEJCPuAFU3S"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/src/Backoffice/Button/Button.scss
// module id = ./node_modules/wix-style-react/src/Backoffice/Button/Button.scss
// module chunks = 0